export default __webpack_public_path__ + "static/media/site-promo-small.8b217476.mov";